import Download from '@crehana/compass.icons.outline/Download';
import { Button } from '@crehana/compass.ui/v3/button';
import { DashboardPageLayout } from '@crehana/compass.web/page-layout/dashboard';

import { Helmet } from '@modern-js/runtime/head';

import { usePageHeaderTitle } from '@/shared/hooks/use-page-header-title';
import { HoursCalculationContent } from './hours-calculation-content';
import { useAddI18nLocales, useTranslation } from './i18n';

export const HoursCalculationPage = () => {
  useAddI18nLocales();
  const { t } = useTranslation();
  const title = usePageHeaderTitle({
    staticTitle: t('PAGE_TITLE'),
    homeBreadcrumb: true,
  });

  const handleDownloadReport = () => {
    // TODO: Implement report download (v2 scope)
    console.log(t('DOWNLOAD_COMING_SOON'));
  };

  return (
    <DashboardPageLayout
      title={title}
      description={t('PAGE_DESCRIPTION')}
      homeBreadcrumb
      cta={
        <Button
          type="button"
          variant="neutral"
          onClick={handleDownloadReport}
          className="tw-shrink-0"
          size="sm"
        >
          <Download size={18} className="tw-text-current" />
          {t('CTA_DOWNLOAD_REPORT')}
        </Button>
      }
    >
      <Helmet>
        <title>{t('SEO_PAGE_TITLE')}</title>
        <meta name="description" content={t('SEO_PAGE_DESCRIPTION')} />
      </Helmet>

      <HoursCalculationContent />
    </DashboardPageLayout>
  );
};
